import styled from 'styled-components';

const PeriodButtonContainer = styled.ul`
    font-family: Arial, sans-serif;
    font-weight: bold;
    display: table;
    margin: 0 auto;
    -webkit-font-smoothing: antialiased;
`;

export { PeriodButtonContainer };
